const t = {
  name: "Scalability",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.00098 2C3.34477 2 2 3.34251 2 5V7H4V5C4 4.44835 4.44806 4 5.00098 4H18.999C19.5519 4 20 4.44835 20 5V19C20 19.5523 19.5523 20 19 20H17V22H19C20.6569 22 22 20.6569 22 19V5C22 3.34251 20.6552 2 18.999 2H5.00098Z" fill="currentColor"/>
<path d="M8 16V18H10V16H12V14H10V12H8V14H6V16H8Z" fill="currentColor"/>
<path d="M2 11C2 9.34315 3.34315 8 5 8H13C14.6569 8 16 9.34315 16 11V19C16 20.6569 14.6569 22 13 22H5C3.34315 22 2 20.6569 2 19V11ZM5 10C4.44772 10 4 10.4477 4 11V19C4 19.5523 4.44772 20 5 20H13C13.5523 20 14 19.5523 14 19V11C14 10.4477 13.5523 10 13 10H5Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Scalability
};
